<template>
    <section 
        :id="home" 
        :class="{ 'show': show }" 
        class="bg-emma h-screen md:pt-72 pt-52 relative transition-opacity duration-1000 opacity-0">
        
        <div class="flex justify-center gap-24 items-center mx-10 ">
            <div class="text-center">
                <h1 class="text-8xl text-cv">Emma Nabyt</h1>
            </div>
        </div>

        <div class="flex justify-center mt-7">
            <div class="w-1/2 bg-gray-200 h-1.5">
                <div class="progress-bar rounded-full" :style="{ width: progress + '%' }"></div>
            </div>
        </div>
    </section>
</template>


<script>
export default {
    data() {
        return {
            show: false,
            progress: 0
        };
    },
    mounted() {
        this.startProgress();
        
        // Ajouter un délai pour activer la transition
        setTimeout(() => {
            this.show = true;
        }, 100); 

        setTimeout(() => {
            this.$router.push({ name: 'home' });
        }, 2000);
    },
    methods: {
        startProgress() {
            let interval = setInterval(() => {
                if (this.progress < 100) {
                    this.progress += 1;
                } else {
                    clearInterval(interval); // Arrêter l'animation à 100%
                }
            }, 16); // Vitesse de l'animation
        }
    }
};
</script>

<style scoped>
.show {
  opacity: 1;
}

.progress-container {
  width: 100%;
  height: 10px;
  background-color: #eee;
  overflow: hidden;
  position: relative;
}

.progress-bar {
  height: 100%;
  background-color: #947968;
  transition: width 0.1s linear;
}

.progress-text {
  text-align: center;
  margin-top: 5px;
  font-size: 16px;
  font-weight: bold;
}
</style>